class LqdBananasHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);
    
    this.handleDestroy();

    this.initParallax();

  }

  getDefaultSettings() {
    return {
      selectors: {
        parallaxElement: '[data-parallax]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $parallaxElement: this.$element.find(selectors.parallaxElement),
    }
  }

  initParallax() {

    this.elements.$parallaxElement.liquidParallax();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleParallaxDestroy();

  }

  handleParallaxDestroy() {

    if ( ! this.elements.$parallaxElement.length ) return;

    const parallaxData = this.elements.$parallaxElement.data('plugin_liquidParallax');

    if ( parallaxData ) {
      parallaxData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdBananasHandler, { $element } );
};